import React from "react";
import PropTypes from "prop-types";
import ModalWrapper from "../components/ModalWrapper";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { isSuccessSubmitShoppingCart } from "../modules/shoppingCart";
import _ from "lodash/fp";

const AddToCartSuccessAdvice = ({
  successSubmit,
  match: {
    params: { dealer_id }
  }
}) => {
  return (
    <ModalWrapper
      title="Success"
      size="md"
      initialOpen={successSubmit}
      render={({ hide }) => (
        <div className="container-fluid">
          <p>Product added to cart successfuly, what is your next step?</p>
          <div className="row">
            <div className="col">
              <Link
                to={dealer_id ? `/dealers/${dealer_id}/products` : "/products"}
              >
                Continue shopping
              </Link>
            </div>
            <div className="col">
              <Link
                to={
                  dealer_id
                    ? `/dealers/${dealer_id}/shopping-cart`
                    : "/shopping-cart"
                }
              >
                Go to cart
              </Link>
            </div>
          </div>
        </div>
      )}
    />
  );
};

AddToCartSuccessAdvice.propTypes = {
  successSubmit: PropTypes.bool.isRequired
};

export default _.pipe(
  withRouter,
  connect(state => ({
    successSubmit: isSuccessSubmitShoppingCart(state)
  }))
)(AddToCartSuccessAdvice);
